
import React from "react";
import { Activity, Car, TrendingUp } from "lucide-react";

/**
 * Reusable violation list component
 * 
 * @param {Array} violations - Array of violation objects
 * @param {string} className - Additional CSS classes
 */
export default function ViolationList({ violations = [], className = "" }) {
  // Default violations if none provided
  const defaultViolations = [
    {
      id: 1,
      type: "Speed violation",
      // location: "Main Street",
      count: 0,
      // time: "8:30 AM",
      icon: Activity,
      iconColor: "cyan",
      severity: "high",
    },
    {
      id: 2,
      type: "Road Crossing violation",
      // location: "Park Avenue",
      count: 0,
      // time: "9:15 AM",
      icon: Car,
      iconColor: "blue",
      severity: "high",
    },
    {
      id: 3,
      type: "Near miss",
      // location: "Highway 101",
      count: 0,
      // time: "10:00 AM",
      icon: TrendingUp,
      iconColor: "indigo",
      severity: "medium",
    },
  ];

  const displayViolations = violations.length > 0 ? violations : defaultViolations;

  const getIconColorClass = (color) => {
    const colorMap = {
      cyan: "bg-cyan-100 text-cyan-600",
      blue: "bg-blue-100 text-blue-600",
      indigo: "bg-indigo-100 text-indigo-600",
      red: "bg-red-100 text-red-600",
      orange: "bg-orange-100 text-orange-600",
      green: "bg-green-100 text-green-600",
    };
    return colorMap[color] || "bg-gray-100 text-gray-600";
  };

  const getCountColorClass = (severity) => {
    const severityMap = {
      high: "text-red-600",
      medium: "text-orange-600",
      low: "text-green-600",
    };
    return severityMap[severity] || "text-green-600";
  };

  return (
    <div className={`bg-white rounded-lg p-3 border border-gray-200 overflow-hidden ${className}`}>
      <h3 className="text-sm font-medium text-gray-700 mb-2">Recent Violations (Coming Soon)</h3>
      
      <div className="space-y-2 h-[calc(100%-2rem)] overflow-y-auto">
        {displayViolations.map((violation) => {
          const Icon = violation.icon;
          
          return (
            <div
              key={violation.id}
              className="flex items-center justify-between py-1.5 border-b last:border-b-0 hover:bg-gray-50 transition-colors rounded px-1"
            >
              <div className="flex items-center gap-2 min-w-0 flex-1">
                <div
                  className={`w-6 h-6 sm:w-7 sm:h-7 rounded-full flex items-center justify-center flex-shrink-0 ${getIconColorClass(
                    violation.iconColor
                  )}`}
                >
                  <Icon size={12} />
                </div>
                <div className="min-w-0 flex-1">
                  <p className="text-xs sm:text-sm font-medium truncate">
                    {violation.type}
                  </p>
                  <p className="text-xs text-gray-500 truncate">
                    {violation.location}
                  </p>
                </div>
              </div>
              <div className="text-right flex-shrink-0">
                <p
                  className={`text-xs sm:text-sm font-semibold ${getCountColorClass(
                    violation.severity
                  )}`}
                >
                  {violation.count}
                </p>
                <p className="text-xs text-gray-500">{violation.time}</p>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}